// src/pages/AccountPage.jsx
import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { Container, Row, Col, Card, ListGroup, Button, Form, Modal } from 'react-bootstrap';

function AccountPage() {
  const { user, logout, updateUserInfo, changePassword } = useAuth(); // Thêm các hàm mới từ AuthContext

  // State để quản lý modal
  const [showEditModal, setShowEditModal] = useState(false);
  const [showPasswordModal, setShowPasswordModal] = useState(false);
  const [editData, setEditData] = useState({
    name: user?.name || '',
    email: user?.email || '',
    address: user?.address || '',
    phone: user?.phone || '',
  });
  const [passwordData, setPasswordData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
  });
  const [error, setError] = useState('');
  const [success, setSuccess] = useState('');

  if (!user) {
    console.warn("AccountPage: User data not found, redirecting.");
    return <p className="text-center my-5">Đang tải thông tin người dùng...</p>;
  }

  const handleLogout = () => {
    logout();
  };

  const handleEditSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    try {
      await updateUserInfo(editData); // Gọi hàm từ AuthContext
      setSuccess('Cập nhật thông tin thành công!');
      setShowEditModal(false);
    } catch (err) {
      setError(err.message || 'Cập nhật thông tin thất bại. Vui lòng thử lại.');
    }
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setSuccess('');

    if (passwordData.newPassword !== passwordData.confirmPassword) {
      setError('Mật khẩu mới và xác nhận mật khẩu không khớp.');
      return;
    }

    try {
      await changePassword({
        currentPassword: passwordData.currentPassword,
        newPassword: passwordData.newPassword,
      });
      setSuccess('Đổi mật khẩu thành công!');
      setShowPasswordModal(false);
      setPasswordData({ currentPassword: '', newPassword: '', confirmPassword: '' });
    } catch (err) {
      setError(err.message || 'Đổi mật khẩu thất bại. Vui lòng thử lại.');
    }
  };

  return (
    <Container className="my-4">
      <Row className="justify-content-center">
        <Col md={8} lg={6}>
          <Card className="shadow-sm">
            <Card.Header as="h4" className="bg-light text-center">
              Thông tin tài khoản
            </Card.Header>
            <Card.Body>
              {success && <div className="alert alert-success">{success}</div>}
              {error && <div className="alert alert-danger">{error}</div>}
              <ListGroup variant="flush">
                <ListGroup.Item>
                  <strong>Tên hiển thị:</strong> {user.name}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Email:</strong> {user.email}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Địa chỉ:</strong>{' '}
                  {user.address || <span className="text-muted">(Chưa cập nhật)</span>}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>Số điện thoại:</strong>{' '}
                  {user.phone || <span className="text-muted">(Chưa cập nhật)</span>}
                </ListGroup.Item>
                <ListGroup.Item>
                  <strong>User ID:</strong> {user.id} {/* Chỉ để demo */}
                </ListGroup.Item>
              </ListGroup>

              <hr />

              <div className="d-flex flex-column flex-sm-row justify-content-around mt-3 gap-2">
                <Button variant="outline-primary" size="sm" onClick={() => setShowEditModal(true)}>
                  <i className="bi bi-pencil-square me-1"></i> Chỉnh sửa thông tin
                </Button>
                <Button variant="outline-secondary" size="sm" onClick={() => setShowPasswordModal(true)}>
                  <i className="bi bi-key me-1"></i> Đổi mật khẩu
                </Button>
                <Button variant="outline-danger" size="sm" onClick={handleLogout}>
                  <i className="bi bi-box-arrow-right me-1"></i> Đăng xuất
                </Button>
              </div>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      {/* Modal chỉnh sửa thông tin */}
      <Modal show={showEditModal} onHide={() => setShowEditModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Chỉnh sửa thông tin</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handleEditSubmit}>
            <Form.Group className="mb-3" controlId="editName">
              <Form.Label>Tên hiển thị</Form.Label>
              <Form.Control
                type="text"
                value={editData.name}
                onChange={(e) => setEditData({ ...editData, name: e.target.value })}
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="editEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                value={editData.email}
                onChange={(e) => setEditData({ ...editData, email: e.target.value })}
                required
                disabled // Email thường không cho phép chỉnh sửa
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="editAddress">
              <Form.Label>Địa chỉ</Form.Label>
              <Form.Control
                type="text"
                value={editData.address}
                onChange={(e) => setEditData({ ...editData, address: e.target.value })}
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="editPhone">
              <Form.Label>Số điện thoại</Form.Label>
              <Form.Control
                type="tel"
                value={editData.phone}
                onChange={(e) => setEditData({ ...editData, phone: e.target.value })}
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Lưu thay đổi
            </Button>
          </Form>
        </Modal.Body>
      </Modal>

      {/* Modal đổi mật khẩu */}
      <Modal show={showPasswordModal} onHide={() => setShowPasswordModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Đổi mật khẩu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={handlePasswordSubmit}>
            <Form.Group className="mb-3" controlId="currentPassword">
              <Form.Label>Mật khẩu hiện tại</Form.Label>
              <Form.Control
                type="password"
                value={passwordData.currentPassword}
                onChange={(e) =>
                  setPasswordData({ ...passwordData, currentPassword: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="newPassword">
              <Form.Label>Mật khẩu mới</Form.Label>
              <Form.Control
                type="password"
                value={passwordData.newPassword}
                onChange={(e) =>
                  setPasswordData({ ...passwordData, newPassword: e.target.value })
                }
                required
              />
            </Form.Group>
            <Form.Group className="mb-3" controlId="confirmPassword">
              <Form.Label>Xác nhận mật khẩu mới</Form.Label>
              <Form.Control
                type="password"
                value={passwordData.confirmPassword}
                onChange={(e) =>
                  setPasswordData({ ...passwordData, confirmPassword: e.target.value })
                }
                required
              />
            </Form.Group>
            <Button variant="primary" type="submit">
              Đổi mật khẩu
            </Button>
          </Form>
        </Modal.Body>
      </Modal>
    </Container>
  );
}

export default AccountPage;